import {trpc} from "@/app/trpc";
import {Loader, StickyHeader, Tab, YStack, TabList} from "@chayka/ui";
import {TabGroup, TabPanel, TabPanels} from "@headlessui/react";
import {useQuery} from "@tanstack/react-query";
import {ServiceCard} from "@/components";

export const ServicesPage = () => {
  const {data, isFetching} = useQuery(trpc.rooms.list.queryOptions());

  if (isFetching) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <StickyHeader title="Услуги" />
      {isFetching && (
        <div className="flex items-center justify-center">
          <Loader />
        </div>
      )}
      {!isFetching && (
        <TabGroup className="flex flex-col gap-4">
          <TabList className="-mx-6 px-6">
            <Tab>Барабанные классы</Tab>
            <Tab>Студия звукозаписи</Tab>
            <Tab>Репетиционные комнаты</Tab>
            <Tab>Вокальные классы</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <YStack className="gap-4">
                {data?.drums.map((service) => (
                  <ServiceCard key={service.id} service={service} />
                ))}
              </YStack>
            </TabPanel>

            <TabPanel>
              <YStack className="gap-4">
                {data?.recording.map((service) => (
                  <ServiceCard key={service.id} service={service} />
                ))}
              </YStack>
            </TabPanel>

            <TabPanel>
              <YStack className="gap-4">
                {data?.rehearsal.map((service) => (
                  <ServiceCard key={service.id} service={service} />
                ))}
              </YStack>
            </TabPanel>

            <TabPanel>
              <YStack className="gap-4">
                {data?.vocal.map((service) => (
                  <ServiceCard key={service.id} service={service} />
                ))}
              </YStack>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      )}
    </>
  );
};
